import React, { useEffect, useRef, useState } from "react"
import Input from "@react/shared/ui/Input"

const ManagerAutocomplete = ({ managers, value, onChange }) => {
  const [query, setQuery] = useState("")
  const [open,  setOpen]  = useState(false)
  const wrapRef = useRef(null)

  useEffect(() => {
    const onDocClick = event => {
      if (wrapRef.current?.contains(event.target)) return
      setOpen(false)
      setQuery("")
    }
    document.addEventListener("click", onDocClick, true)
    return () => document.removeEventListener("click", onDocClick, true)
  }, [])

  const selected = managers.find(manager => String(manager.id) === String(value)) || null
  const display  = open ? query : (selected?.name || "")
  const needle   = query.trim().toLowerCase()
  const results  = needle
    ? managers.filter(manager => (manager.name || "").toLowerCase().includes(needle))
    : managers

  const pick = manager => {
    onChange(manager.id)
    setQuery("")
    setOpen(false)
  }

  return (
    <div className="relative" ref={wrapRef}>
      <Input
        variant     = "search"
        leadingIcon = "magnifying-glass"
        value       = {display}
        onChange    = {event => { setQuery(event.target.value); setOpen(true) }}
        onFocus     = {() => { setOpen(true); setQuery("") }}
        placeholder = {I18n.t("quotes.bigcard.select_manager")}
      />
      {open && (
        <div className="mt-1 bg-white border border-slate-200 rounded-md shadow-sm max-h-64 overflow-y-auto">
          {results.length === 0 ? (
            <div className="px-3 py-2 text-sm text-slate-500">{I18n.t("quotes.project_index.duplicate.no_match")}</div>
          ) : results.map(manager => (
            <button
              key       = {manager.id}
              type      = "button"
              onClick   = {() => pick(manager)}
              className = "w-full text-left px-3 py-2 hover:bg-slate-50 text-sm text-slate-800"
            >
              {manager.name}
            </button>
          ))}
        </div>
      )}
    </div>
  )
}

export default ManagerAutocomplete
